export const LOADING_ACTIVO = "LOADING_ACTIVO";
export const SAVE_LOADING_ACTIVO = "SAVE_LOADING_ACTIVO";
export const GET_ACTIVO = "GET_ACTIVO";
export const FORM_FAIL = "FORM_FAIL";
export const ACTIVO_FAIL = "ACTIVO_FAIL";
export const LOADING_ACTIVO_BY_ID = "LOADING_ACTIVO_BY_ID";
export const GET_ACTIVO_BY_ID = "GET_ACTIVO_BY_ID";
